<template>
    
 <div v-if="computeUserAccess && hasChatPersons">

<divider title="language.recent_chats"/>

    <page-padding>
      <div class="no-message" v-if="!hasChatPersons">{{$t('language.no_recent_chats')}}</div>

        <div>
          <div class="featured_container" v-for='(item, index) in sliceArray(filteredChatPersons,3)' v-bind:key="item.id">
              <button-chat-person-featured :item="item" :key="index + item.name" :to="'/chat/'+item.id"/>
          </div>
        </div>
        
        <button-more title="language.view_more_chats" to="/chatpersons"/>

  </page-padding>

  </div>
</template>

<script>

import { mapState } from 'vuex';
import PagePadding from '../../components/PagePadding';
import ButtonChatPersonFeatured from './ButtonChatPersonFeatured.vue';
import ButtonMore from '../../components/buttons/ButtonMore';
import Divider from '../../components/dividers/Divider.vue';
import { USER_LEVEL } from '../../settings/USER_LEVEL.js';

export default {
  name: 'list-chat-persons-featured',
  props:{
  },
  data:function(){
    return {
      showLoader:false,
    }
  },
  components:{
    PagePadding,
    ButtonChatPersonFeatured,
    ButtonMore,
    Divider,
  },
  methods:{
    load_chat_persons(){
      this.$store.dispatch('get_chat_persons',{}).then(()=>{

      })
    },
    sliceArray(arr,count){
      if(arr){
        return arr.slice(0,count)
      }else{
        return [];
      }
    },
  },
  computed:{
    ...mapState([
       'chatpersons','appSettings',
      ]),
      computeUserAccess(){
         if (this.appSettings.user_level==USER_LEVEL.PARENT){
           return true;
         }
         if (this.appSettings.user_level==USER_LEVEL.TEACHER){
           return true;
         }
         if (this.appSettings.user_level==USER_LEVEL.STUDENT){
           return false;
         }
         if (this.appSettings.user_level==USER_LEVEL.ADMIN){
           return true;
         }
         return false;
      
       },
       hasChatPersons:function(){
         
         if(this.filteredChatPersons){
           return this.filteredChatPersons ? this.filteredChatPersons.length : false;
         }else{
           return false;
         }
         
       },
       filteredChatPersons() {
        
         // sort on last message date
        var persons=[...this.chatpersons];
        
        

        // sort on date 
        persons = persons.sort( (a ,b ) => {
          
          var date_a=Date.parse( a.last_chat.datetime.replace(/-/g, '/') ); // for ios date must be with "/"
          var date_b=Date.parse( b.last_chat.datetime.replace(/-/g, '/') ); // for ios date must be with "/"

          if( isNaN(date_a) ){
            date_a=0;
          }

          if( isNaN(date_b) ){
            date_b=0;
          }
          
          return (date_b - date_a);

        });
        

        // filter out persons without last chat message
        persons = persons.filter((item)=>{
          if(item.last_chat.message!=""){
            return true;
          }else{
            return false;
          }
        })



        return persons;

      
    },
    
  },
  created:function(){
    this.load_chat_persons();
    
  },  
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .featured_container{
  padding:25px 0px;
  border-bottom: 1px solid #DDDDDD;
}
.featured_container:first-child{
  border-top: 1px solid #DDDDDD;
  margin-top:15px;
}
.featured_container:last-child{
  margin-bottom:15px;
}
.no-message{
  padding-bottom:20px;
}

</style>

